module.exports = __webpack_public_path__ + "static/media/STEPS-3 Verlängerungsstudie 42 Monate_Seidner DL et al., Nutr Clin Pract 2018;33.4216f4c5.pdf";